import { apiCall } from "./apiservice";
import Methods from "./methods.json";


class ScoreCalculationApi {

  static calculateInsuranceScore(params) {
    return new Promise((resolve, reject) => {
      apiCall(`calc/getHumanLifeValueCalcResult?${params}`, Methods.POST, {}, true).then((response) => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }

  static calculateRRScore(params) {
    return new Promise((resolve, reject) => {
      apiCall(`Calculations/RRScoreCalculation?${params}`, Methods.GET).then((response) => {
        resolve(response.data)
      }).catch(error => {
        reject(error);
      })
    });
  }

  static calculateSustainAbilityScore(params) {
    return new Promise((resolve, reject) => {
      apiCall(`Calculations/SustainabilityScore?${params}`, Methods.GET).then((response) => {
        resolve(response.data)
      }).catch(error => {
        reject(error);
      })
    });
  }

}

export default ScoreCalculationApi;